<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-input
          clearable
          style="width:200px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入会员名称/电话号码"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="选择角色"
          v-model="searchCondition.roleType"
          filterable
        >
          <el-option label="导购" value="guider"></el-option>
          <el-option label="推会员" value="shareMember"></el-option>
          <el-option label="导购/推会员" value="both"></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="请选择成长值等级"
          v-model="searchCondition.growthId"
          filterable
        >
          <el-option
            :label="v.growthName"
            :value="v.growthId"
            v-for="(v, i) in czList"
            :key="i"
          ></el-option>
        </el-select>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          start-placeholder="选择统计开始时间"
          end-placeholder="统计结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('list')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="idcardName"
          label="会员姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="authMobile"
          label="会员电话号码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalGrown"
          label="当前成长值/等级名称"
          :width="180"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.totalGrown }}/{{ scope.row.growthName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="roleType"
          label="角色"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.roleType === 'shareMember'">推会员</span>
            <span v-if="scope.row.roleType === 'guider'">导购</span>
            <span v-if="scope.row.roleType === 'both'">推会员/导购</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalRemainIntegral"
          label="积分余额"
        >
          <template slot-scope="scope">
            <div class="success">{{ scope.row.totalRemainIntegral }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalIntegral"
          label="获得积分"
        >
          <template slot-scope="scope">
            <div class="success">{{ scope.row.totalIntegral }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalConsumeIntegral"
          label="消耗积分"
        >
          <template slot-scope="scope">
            <div class="danger">{{ scope.row.totalConsumeIntegral }}</div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="totalDeductionIntegral"
          label="扣减积分"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="flow(scope.row)"
                >积分流水</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="积分流水"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="detailsVisible = false"
      width="70%"
      custom-class="sales-volumn-dialog"
    >
      <div class="tables">
        <el-table stripe :data="[row]" style="width: 100%" size="small">
          <el-table-column
            prop="idcardName"
            label="会员名称"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="authMobile"
            label="电话"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="roleType"
            label="角色"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.roleType === 'shareMember'">推会员</span>
              <span v-if="scope.row.roleType === 'guider'">导购</span>
              <span v-if="scope.row.roleType === 'both'">推会员/导购</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalRemainIntegral"
            label="积分余额"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="success">{{ scope.row.totalRemainIntegral }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-panel flex flex-end mt20" style="marginTop:50px">
        <div>
          <el-input
            clearable
            v-model.trim="searchDetails.flowSn"
            placeholder="请输入流水号"
            size="small"
            class="ipt mr10"
          ></el-input>

          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="请选择流水类型"
            v-model="searchDetails.flowType"
            filterable
          >
            <el-option label="扣减" value="sub"></el-option>
            <el-option label="消耗" value="use"></el-option>
            <el-option label="获得" value="get"></el-option>
          </el-select>
          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            v-model="searchDetails.applyDate"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
          ></el-date-picker>
          <el-button type="primary" size="small" @click="searchFlow"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output('details')"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          stripe
          border
          ref="flowtable"
          :data="flowList"
          style="width: 100%"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPageFlow - 1) * pageSizeFlow + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="flowSn"
            label="流水号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="flowType"
            label="流水类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.flowType === 'sub'">扣减</span>
              <span v-if="scope.row.flowType === 'use'">消耗</span>
              <span v-if="scope.row.flowType === 'get'">获得</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="flowChangeReason"
            label="积分行为"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="flowChangeTime"
            label="发生时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="changeValue"
            label="数量"
          >
            <template slot-scope="scope">
              <div class="danger">
                {{ scope.row.flowType !== "get" ? "-" : "+"
                }}{{ scope.row.changeValue }}
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="orderSn"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" @click="flow(scope.row)"
                  >积分流水</el-button
                >
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalFlow"
            @current-change="pagingFlow"
            @size-change="handleSizeChangeFlow"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPageFlow"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      searchCondition: {},
      searchDetails: {},
      isOutputing: false,
      row: {},
      list: [],
      czList: [],
      flowList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      currentPageFlow: 1,
      pageSizeFlow: 10,
      totalFlow: 0
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryGrowthInfoList();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.statisticsStartTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.statisticsEndTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryIntegralList",
        params
      );
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    async queryGrowthInfoList() {
      const { result } = await this.$store.dispatch("queryGrowthInfoList", {
        dictCode: "period_days"
      });
      this.czList = result.growthInfoList;
    },
    async queryFlowList() {
      let params = {
        pageNo: this.currentPageFlow,
        pageSize: this.pageSizeFlow,
        customerId: this.row.customerId
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchDetails));
      searchCondition.flowChangeStartTime =
        this.searchDetails.applyDate && this.searchDetails.applyDate.length > 0
          ? this.searchDetails.applyDate[0]
          : "";
      searchCondition.flowChangeEndTime =
        this.searchDetails.applyDate && this.searchDetails.applyDate.length > 0
          ? this.searchDetails.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "integralFlowDetails",
        params
      );
      const { records, total } = result;
      this.flowList = records;
      this.totalFlow = total;
    },
    queryAllFlowList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        customerId: this.row.customerId
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchDetails));
      searchCondition.flowChangeStartTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.flowChangeEndTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("allIntegralFlowDetails", params);
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 999999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.statisticsStartTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.statisticsEndTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllIntegralList", params);
    },
    flow(row) {
      this.row = row;
      this.dialogVisible = true;
      this.queryFlowList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    searchFlow() {
      this.currentPageFlow = 1;
      this.queryFlowList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingFlow(page) {
      this.currentPageFlow = page;
      this.queryFlowList();
    },
    handleSizeChangeFlow(size) {
      this.currentPageFlow = 1;
      this.pageSizeFlow = size;
      this.queryFlowList();
    },
    output(val) {
      if (val === "list") {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          this.isOutputing = true;

          this.queryAllList()
            .then(res => {
              let list = res.result.records;
              list.forEach(v => {
                if (v.roleType === "shareMember") {
                  v.roleType = "推会员";
                } else if (v.roleType === "guider") {
                  v.roleType = "导购";
                } else if (v.roleType === "both") {
                  v.roleType = "推会员/导购";
                }
              });
              let tHeader = this.$refs.table.columns
                .map(o => o.label !== "序号" && o.label)
                .filter(o => o);

              let filterVal = [];
              if (list.length > 0) {
                filterVal = this.$refs.table.$children
                  .map(o => o._props.prop)
                  .filter(o => o);
              }

              let title = "积分统计";

              let data = this.formatJson(filterVal, list);

              exportJsonToExcel(
                tHeader,
                data,
                title + new Date().toLocaleString()
              );
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
        });
      } else if (val === "details") {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          this.isOutputing = true;

          this.queryAllFlowList()
            .then(res => {
              let list = res.result.records;
              list.forEach(v => {
                if (v.flowType === "sub") {
                  v.flowType = "扣减";
                  v.changeValue = -v.changeValue;
                } else if (v.flowType === "use") {
                  v.flowType = "消耗";
                  v.changeValue = -v.changeValue;
                } else if (v.flowType === "get") {
                  v.flowType = "获得";
                  v.changeValue = +v.changeValue;
                }
              });
              let tHeader = this.$refs.flowtable.columns
                .map(o => o.label !== "序号" && o.label)
                .filter(o => o);

              let filterVal = [];
              if (list.length > 0) {
                filterVal = this.$refs.flowtable.$children
                  .map(o => o._props.prop)
                  .filter(o => o);
              }

              let title = "积分流水";

              let data = this.formatJson(filterVal, list);

              exportJsonToExcel(
                tHeader,
                data,
                title + new Date().toLocaleString()
              );
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.tables {
  border: 1px solid rgba(221, 221, 221, 1);
}
</style>
